<script setup lang="ts">
import KgrModal from '@shared/components/KgrModal.vue';
import { openStore, useCapgo } from '@shared/composables/useCapgo';

// Blocking overlay for the two native update gates (driven by useCapgo):
//  - otaUpdating:      a newer web bundle is being downloaded + applied ("App wird aktualisiert…")
//  - forceStoreUpdate: a newer native binary is in the store and must be installed (iOS only —
//    Android uses Play's in-app update flow and never shows this overlay).
// Both are non-dismissible (no close-on-backdrop, no close button) — usage stays blocked until
// the bundle reload happens or the user updates the binary.
const { otaUpdating, otaProgress, forceStoreUpdate } = useCapgo();
</script>

<template>
    <KgrModal
        :open="otaUpdating || forceStoreUpdate"
        max-width="420px"
        :close-on-backdrop-click="false"
    >
        <template v-if="forceStoreUpdate">
            <div class="kgr-modal__header kgr-region kgr-region--accent">
                <h2 class="kgr-headline kgr-headline--h3">
                    {{ $t('Update erforderlich') }}
                </h2>
            </div>
            <div class="kgr-modal__content kgr-region kgr-text kgr-text--centered">
                {{ $t('Bitte aktualisiere die App im Store, um fortzufahren.') }}
            </div>
            <div class="kgr-modal__footer kgr-region kgr-postfix kgr-postfix--gutters">
                <button
                    type="button"
                    class="kgr-button kgr-button--block"
                    @click="openStore"
                >
                    {{ $t('Im Store öffnen') }}
                </button>
            </div>
        </template>

        <template v-else>
            <div class="kgr-modal__content kgr-region kgr-text kgr-text--centered ota-updating">
                <div class="kgr-loadingIndicator"></div>
                <div class="kgr-headline kgr-headline--h3">
                    {{ $t('App wird aktualisiert …') }}
                </div>
                <div class="kgr-text kgr-text--small">
                    {{ otaProgress }} %
                </div>
            </div>
        </template>
    </KgrModal>
</template>

<style scoped lang="scss">
.ota-updating {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}
</style>
